import React from 'react';

import { Box, Text } from '@simplybusiness/mobius-simplybusiness';
import { telephone } from '@simplybusiness/icons';

import CustomerServiceContact from './CustomerServiceContact';
import CircleIcon from '../atoms/CircleIcon';

const PleaseCallUs = () => (
  <Box style={{ textAlign: 'center', width: '100%' }}>
    <CircleIcon icon={telephone} variant="magenta" />
    <Text
      component="h1"
      marginTop="size-60"
      fontSize={31}
      fontWeight={700}
    >
      <CustomerServiceContact />
    </Text>
  </Box>
);

export default PleaseCallUs;
